import React, { Component } from "react";
import { connect } from "react-redux";
import { SketchPicker } from "react-color";
import "./ColorPicker.scss";

class ColorPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      colorPicker: false,
    };
  }
  componentDidMount = () => {};

  render() {
    const presetArray = ["#000000", "#ffffff", ...this.props.preset];

    return (
      <div className="colorTool">
        <button
          style={{ padding: "8px 5px 8px 5px" }}
          className="color-picker-button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            this.setState({ colorPicker: !this.state.colorPicker });
          }}
        >
          <svg width="18.999" height="19.208" viewBox="0 0 18.999 19.208">
            <path
              id="Union_20"
              data-name="Union 20"
              d="M-6702-6550v-3h18v3Zm12.75-6.75c0-.994,1.485-2.608,1.5-2.625l.005.005c.153.169,1.5,1.687,1.5,2.62a1.5,1.5,0,0,1-1.5,1.5A1.5,1.5,0,0,1-6689.25-6556.75Zm-6.045,1.169-4.124-4.124a1.1,1.1,0,0,1-.332-.787,1.126,1.126,0,0,1,.332-.8l3.862-3.862-1.785-1.785,1.058-1.058,6.7,6.7a1.126,1.126,0,0,1,.332.8,1.11,1.11,0,0,1-.332.787l-4.125,4.124a1.125,1.125,0,0,1-.794.33A1.131,1.131,0,0,1-6695.3-6555.581Zm-2.8-4.919h7.186l-3.593-3.593Z"
              transform="translate(6702.5 6568.707)"
              fill="#0c3254"
              stroke="rgba(0,0,0,0)"
              strokeWidth="1"
            />
          </svg>
          {this.props.btnLabel}
        </button>
        <div className="clearfix"></div>
        <span className="colorCode">
          {typeof this.props.colorValue !== "string" && this.props.colorValue
            ? `
              R: ${this.props.colorValue.r}
              G: ${this.props.colorValue.g}
              B: ${this.props.colorValue.b}
              A: ${this.props.colorValue.a}
            `
            : typeof this.props.colorDefaultValue !== "string"
            ? `
              R: ${this.props.colorDefaultValue.r || "252"}
              G: ${this.props.colorDefaultValue.g || "252"}
              B: ${this.props.colorDefaultValue.b || "252"}
              A: ${this.props.colorDefaultValue.a || "1"}
            `
            : this.props.colorDefaultValue}
        </span>
        {this.state.colorPicker && (
          <div
            className="colorPickerWrapper"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <div
              className="overlayColor"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                this.setState({ colorPicker: false });
              }}
            ></div>
            <SketchPicker            
              className="sketch-picker"
              disableAlpha={
                this.props.disableAlpha ? this.props.disableAlpha : false
              }
              presetColors={presetArray}
              color={
                typeof this.props.colorValue == "string"
                  ? this.props.colorDefaultValue
                  : this.props.colorValue
              }
              onChange={(color) => {
                this.props.getColor(color);
              }}
            />

            {this.props.children}
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    preset: state.present.preset,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(ColorPicker);
